import {Pages} from '../../assets/ts/customTypes';
import {MainContainer} from '../../assets/ts/layout/main';
import {ContentContainer} from '../../assets/ts/layout/content';
import {LandingpageClickable} from '../components/LandingpageClickable';
import {LandingpageButton} from '../components/LandingpageButton';
import { LandingpageButtonContainer } from '../../assets/ts/pages/landingpage';
import { LandingpageImage } from '../components/LandingpageImage';
import { PageTitle } from '../components/PageTitle';
import { LandingpageArrow } from '../components/LandingpageArrow';
import { useLanguage } from '../contexts/LanguageContext';


export function Landingpage({
    onChangePage,
}: {
    onChangePage: (page: Pages) => void
}) {
    const [language] = useLanguage();
    const {buttonContact, buttonTestimonials, tooltips} = language[Pages.LANDINGPAGE];
    return (
        <MainContainer>
            <PageTitle width={language.landingpage.headlineWidth}>{language.landingpage.headline}</PageTitle>
            <LandingpageButtonContainer>
                <LandingpageButton
                    onClick={() => onChangePage(Pages.KONTAKT)}
                    width={285}
                >{buttonContact}</LandingpageButton>
                <LandingpageButton
                    onClick={() => onChangePage(Pages.KUNDENZITATE)}
                    width={400}
                >{buttonTestimonials}</LandingpageButton>
            </LandingpageButtonContainer>
            <ContentContainer>
                <LandingpageImage
                    offsetLeft={8}
                    offsetTop={22}
                    width={250}
                    position={1}
                    src={language.landingpage.images.leftUpper}
                />
                <LandingpageImage
                    offsetLeft={8}
                    offsetTop={51}
                    width={250}
                    position={1}
                    imgWidth={1700}
                    src={language.landingpage.images.leftLower}
                />
                <LandingpageImage
                    offsetLeft={76}
                    offsetTop={15}
                    width={700}
                    position={7}
                    imgWidth={552}
                    imgHeight={577}
                    src={language.landingpage.images.big}
                    isBig
                />
                <LandingpageArrow type={'upper'} />
                <LandingpageArrow type={'lower'} />
                <LandingpageArrow type={'right'} />
                <LandingpageClickable
                    page={Pages.TEILEIDENTIFIKATION}
                    offsetLeft={12}
                    offsetTop={32.7}
                    width={700}
                    position={1}
                    description={tooltips.identification}
                    onChangePage={onChangePage}
                />
                <LandingpageClickable
                    page={Pages.KATALOGSCHNITTSTELLE}
                    offsetLeft={35}
                    offsetTop={32.7}
                    width={700}
                    position={3}
                    description={tooltips.catalogue}
                    onChangePage={onChangePage}
                />
                <LandingpageClickable
                    page={Pages.LAGERERGAENZUNG}
                    offsetLeft={12}
                    offsetTop={61}
                    width={700}
                    position={1}
                    description={tooltips.storage}
                    onChangePage={onChangePage}
                />
                <LandingpageClickable
                    page={Pages.NETTOPREISSCHNITTSTELLE}
                    offsetLeft={28}
                    offsetTop={61}
                    width={700}
                    position={2}
                    description={tooltips.price}
                    onChangePage={onChangePage}
                />
                <LandingpageClickable
                    page={Pages.VERFUEGBARKEITSSCHNITTSTELLE}
                    offsetLeft={40}
                    offsetTop={61}
                    width={700}
                    position={4}
                    description={tooltips.availability}
                    onChangePage={onChangePage}
                />
                <LandingpageClickable
                    page={Pages.BESTELLSCHNITTSTELLE}
                    offsetLeft={54}
                    offsetTop={43}
                    width={1200}
                    position={5}
                    description={tooltips.order}
                    onChangePage={onChangePage}
                />
            </ContentContainer>
        </MainContainer>
    );
}
